/* ============================================================
   Design Trace Library — bundle para Shopify.
   Los 8 archivos del handoff en su orden obligatorio, envueltos en
   un IIFE: ningun global (`open`, `render`, `update`, `list`, `root`,
   `card`, `tabs`, `layout`...) escapa. `open` pisaba window.open.
   Generado por tools/build_240.py — no editar a mano.
   ============================================================ */
(function () {
'use strict';
const ROOT = document.querySelector('.dtl-root');
const BY = id => document.getElementById('dtl-' + id);
async function loadAllSeqGated(){
  const first = REAL_COLS[0];
  if (first && !loaded.has(first.slug)) { await loadCol(first.slug); render(); }
  let armed = true;
  const go = () => {
    if (!armed) return;
    armed = false;
    removeEventListener('scroll', go);
    removeEventListener('touchstart', go);
    loadAllSeq();
  };
  addEventListener('scroll', go, {passive:true});
  addEventListener('touchstart', go, {passive:true});
}
function syncStickyTop(){
  let top = 0;
  const hdr = document.querySelector('sticky-header, .header-wrapper, header');
  if (hdr) {
    let n = hdr;
    while (n && n !== document.body) {
      const pos = getComputedStyle(n).position;
      if (pos === 'sticky' || pos === 'fixed') {
        top = (parseFloat(getComputedStyle(n).top) || 0) + n.offsetHeight;
        break;
      }
      n = n.parentElement;
    }
  }
  ROOT.style.setProperty('--dtl-top', Math.round(top) + 'px');
}
addEventListener('resize', syncStickyTop);
addEventListener('load', syncStickyTop);
if (document.readyState === 'loading') addEventListener('DOMContentLoaded', syncStickyTop);
else syncStickyTop();
function saveBlob(blob, name){
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  /* Revocar a los 4s cortaba el guardado en navegadores lentos.
     Se libera al salir de la pagina, que es cuando ya no hace falta. */
  addEventListener('pagehide', () => URL.revokeObjectURL(url), {once:true});
}
function centerTab(el, center){
  /* Posiciona la tira de pestañas moviendo SOLO su scrollLeft.
     Se mide con getBoundingClientRect y no con offsetLeft: offsetLeft es
     relativo al offsetParent, que aca no es el contenedor scrollable, y daba
     una posicion equivocada (el primer tab terminaba cortado). */
  if (!el) return;
  const c = el.parentElement; if (!c) return;
  const cb = c.getBoundingClientRect(), eb = el.getBoundingClientRect();
  const left = eb.left - cb.left + c.scrollLeft;      /* posicion dentro del contenido */
  const V = c.clientWidth, W = eb.width, max = c.scrollWidth - V;
  /* Si todavia no hay layout, clientWidth es 0 y la cuenta da basura
     (dejaba el primer tab corrido media pastilla). Reintenta al frame
     siguiente, cuando el navegador ya midio. */
  if (!V) { requestAnimationFrame(() => centerTab(el, center)); return; }
  const clamp = x => Math.min(Math.max(x, 0), Math.max(max, 0));
  if (center) c.scrollLeft = clamp(left - (V - W) / 2);
  else if (left < c.scrollLeft) c.scrollLeft = clamp(left);
  else if (left + W > c.scrollLeft + V) c.scrollLeft = clamp(left + W - V);
}

/* ────── config.js ────── */
/* =============================================================
   config.js — todo lo que el equipo puede querer tocar sin
   entrar en la lógica de la aplicación.
   ============================================================= */

/* Navegación de la cabecera.
   PENDIENTE: los destinos no están definidos. Cambiar `href` por la URL
   real de Resparked, o quitar/agregar entradas, no requiere tocar nada más. */
const NAV = [
  { label: 'All Products',          href: '#', current: false },
  { label: 'Customizer\u2122',       href: '#', current: false },
  { label: 'Design Trace Library',  href: '#', current: true  },
  { label: 'Projects',              href: '#', current: false }
];

/* Nivel de detalle del diseño. Describe el diseño, no la habilidad de quien
   lo usa. El orden define la rampa visual y el de los filtros; minInch es el
   tamaño a partir del cual todas las líneas quedan nítidas.
   Para agregar un nivel: una entrada acá + la regla .badge.<slug> en main.css. */
const LEVELS = [
  { slug: 'simple',    label: 'Simple',    rank: 1, minInch: 1.5 },
  { slug: 'detailed',  label: 'Detailed',  rank: 2, minInch: 2.5 },
  { slug: 'intricate', label: 'Intricate', rank: 3, minInch: 3.5 }
];
const LEVEL_FILTER_LABEL = 'Detail';   // etiqueta del grupo de filtros

/* "More Like This": cuántos diseños relacionados mostrar en el detalle. */
const RELATED_COUNT = 6;

/* Medidas de referencia del paso 1, en pulgadas.
   Tomadas de la superficie grabable del objeto, no del objeto entero. */
const PRESETS = [
  { inch: 1.5, t: 'Keychains, charms & tags' },
  { inch: 3.5, t: 'Coasters, mugs & ornaments' },
  { inch: 8,   t: 'Boards, trays & signs' }
];

/* Hojas soportadas, en cm y en vertical. */
const PAPERS = {
  letter: { name: 'US Letter', w: 612,    h: 792    },   // puntos PDF
  a4:     { name: 'A4',        w: 595.28, h: 841.89 }
};

/* Rutas de datos. Cambiar acá si el hosting sirve los JSON desde otro lugar. */
const DATA_INDEX = window.DTL_INDEX;
const DATA_COLLECTION = slug => window.DTL_COL.replace('SLUG', slug);

/* Resuelve nombres de archivo contra Shopify Content Files.
   La base la inyecta el template Liquid (window.DTL_BASE). */
const ASSET = f => (window.DTL_BASE || '') + f;

/* Derivados — no hace falta tocarlos */
const CM_IN = 2.54, PT_CM = 72 / 2.54, PT_IN = 72;
const RANK   = Object.fromEntries(LEVELS.map(l => [l.slug, l.rank]));
const MIN_CM = Object.fromEntries(LEVELS.map(l => [l.slug, l.minInch * CM_IN]));
const LVLABEL = Object.fromEntries(LEVELS.map(l => [l.slug, l.label]));
const MARGIN = 36, HEAD = 26, FOOT = 72;   // franjas reservadas en la hoja, en pt


/* ────── analytics.js ────── */
/* =============================================================
   analytics.js — GANCHOS PREPARADOS, NO CONECTADOS.
   Ninguna herramienta de analytics está integrada. `track()` no hace
   nada salvo que exista `window.resparkedTrack` o `window.dataLayer`.
   Para conectarlo alcanza con definir uno de los dos antes de app.js.
   Los nombres de evento están documentados en docs/ANALYTICS.md.
   ============================================================= */
function track(event, props = {}) {
  try {
    if (typeof window.resparkedTrack === 'function') {
      window.resparkedTrack(event, props);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...props });
    }
  } catch (e) { /* analytics nunca debe romper la página */ }
}


/* ────── spark.js ────── */
/* =============================================================
   spark.js — la mascota de Resparked.
   Archivos oficiales provistos por Resparked (PNG con transparencia).
   Para cambiarla: reemplazar los PNG de assets/brand/ manteniendo
   el nombre, o cambiar las rutas de acá.
   ============================================================= */
const SPARK_BRUSH = '<img class="dtl-spark" src="' + ASSET('dtl-spark-brush.png') + '" width="269" height="332" alt="" aria-hidden="true">';
const SPARK_ENGRAVE = '<img class="dtl-spark wide" src="' + ASSET('dtl-spark-engraving.png') + '" width="496" height="264" alt="Spark, the Resparked mascot">';
/* alias usado por el mensaje de descarga */
const SPARK_SM = SPARK_BRUSH;


/* ────── data.js ────── */
/* =============================================================
   data.js — capa de datos. El frontend no conoce ningún diseño:
   todo sale de data/index.json y data/collections/*.json.
   ============================================================= */

let COLS = [];          // colecciones visibles, en orden
let INDEX = [];         // metadata de los diseños publicados
let COLNAME = {};       // slug -> nombre visible
let REAL_COLS = [];     // sólo las colecciones con diseños propios

const ART = {};         // id -> {x,y,w,h,d}  (geometría, se carga por colección)
const loaded = new Set();
const pending = {};

/* Carga el índice y arma la lista de colecciones a partir de los datos.
   Una categoría nueva aparece sola con solo existir en los diseños. */
async function loadIndex() {
  const res = await fetch(DATA_INDEX);
  if (!res.ok) throw new Error('No se pudo cargar ' + DATA_INDEX);
  const meta = await res.json();

  INDEX = (meta.designs || [])
    .filter(d => (d.status || 'published') === 'published')
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.id.localeCompare(b.id));

  const counts = {};
  INDEX.forEach(d => { counts[d.c] = (counts[d.c] || 0) + 1; });
  /* Una colección con "includes" agrupa otras (Animals = Sea Life +
     Wild Animals). No tiene diseños propios: su total es la suma. */
  (meta.collections || []).forEach(c => {
    if (c.includes) counts[c.slug] = c.includes.reduce((n, s) => n + (counts[s] || 0), 0);
  });

  COLS = (meta.collections || [])
    .filter(c => counts[c.slug])
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.name.localeCompare(b.name))
    .map(c => ({ ...c, n: counts[c.slug] }));

  COLNAME = Object.fromEntries(COLS.map(c => [c.slug, c.name]));
  REAL_COLS = COLS.filter(c => !c.includes);
  return meta;
}

/* La geometría pesa: se baja una colección por vez, sólo al entrar. */
function loadCol(slug) {
  if (loaded.has(slug)) return Promise.resolve();
  if (pending[slug]) return pending[slug];
  pending[slug] = fetch(DATA_COLLECTION(slug))
    .then(r => r.ok ? r.json() : Promise.reject(r.status))
    .then(list => { list.forEach(a => ART[a.id] = a); loaded.add(slug); })
    .catch(() => {})
    .finally(() => { delete pending[slug]; });
  return pending[slug];
}

/* Una colección agrupada baja la geometría de todas las que incluye. */
async function loadCols(slug) {
  const c = COLS.find(x => x.slug === slug);
  const list = c && c.includes ? c.includes : [slug];
  for (const s of list) await loadCol(s);
}

/* En orden de grilla, para que se llene de arriba hacia abajo. */
function fillLoaded(){
  BY('grid').querySelectorAll('.dtl-sheet.dtl-skel').forEach(sh => {
    const art = sh.closest('.dtl-card');
    const a = art && ART[art.dataset.id];
    if (!a) return;
    sh.classList.remove('dtl-skel');
    sh.insertAdjacentHTML('afterbegin', artSvg(a));
  });
}
async function loadAllSeq() {
  for (const c of REAL_COLS) {
    if (!loaded.has(c.slug)) { await loadCol(c.slug); fillLoaded(); }
  }
}


/* ────── gallery.js ────── */
/* =============================================================
   gallery.js — grilla, pestañas de colección, filtros, búsqueda,
   favoritos y tema. Lee de INDEX/ART; no conoce ningún diseño.
   ============================================================= */
let favs = new Set();
try { favs = new Set(JSON.parse(localStorage.getItem('dtl.favs')||'[]')); } catch(e){}
const saveFavs = () => { try{ localStorage.setItem('dtl.favs', JSON.stringify([...favs])); }catch(e){} };

/* Modo oscuro removido para Shopify: el boton vivia en el header del
   prototipo, y una galeria oscura entre header y footer claros del theme
   se ve rota. Para reponerlo: restaurar los bloques [data-theme] del CSS
   original y este toggle. */

/* ---------- estado ---------- */
let curCol = 'all';
let fLv='all', fFav=false, fQ='';

const cap1 = s => s.charAt(0).toUpperCase()+s.slice(1);
const dots = lv => `<span class="dtl-dots">${LEVELS.map(l=>l.rank).map(i=>`<i class="${i<=RANK[lv]?'dtl-on':''}"></i>`).join('')}</span>`;
const artSvg = a => `<svg class="dtl-art" viewBox="${a.x} ${a.y} ${a.w} ${a.h}" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><path d="${a.d}"/></svg>`;

/* Sin contadores por pestaña: los nombres largos entran enteros y no hay
   ningún número que mantener al día. El total vive en el contador de
   resultados, que se calcula solo. */
function tabs(){
  const all = `<button class="dtl-tab dtl-all" data-c="all" aria-pressed="${curCol==='all'}">All designs</button>`;
  BY('cols').innerHTML = all + COLS.map(c =>
    `<button class="dtl-tab" data-c="${c.slug}" aria-pressed="${c.slug===curCol}">${c.name}</button>`
  ).join('');
}
/* loadAllSeq() vive en data.js — acá sólo se usa. */
const global = () => !!fQ || fFav || curCol==='all';
/* inCol: una colección normal compara el slug; una agrupada (Animals)
   acepta cualquiera de las colecciones que incluye. */
const inCol = (d, slug) => {
  const c = COLS.find(x => x.slug === slug);
  return c && c.includes ? c.includes.includes(d.c) : d.c === slug;
};
function list(){
  const pool = global() ? INDEX : INDEX.filter(d => inCol(d, curCol));
  return pool.filter(d =>
    (fLv==='all' || d.lv===fLv) && (!fFav || favs.has(d.id)) &&
    (!fQ || d.n.toLowerCase().includes(fQ) || COLNAME[d.c].toLowerCase().includes(fQ)));
}
/* Una tarjeta. La usan la grilla y "More Like This", así se ven iguales. */
function card(d, i = 0){
  const a = ART[d.id];
  return `<article class="dtl-card" data-id="${d.id}" style="animation-delay:${Math.min(i,14)*18}ms">
      <div class="dtl-sheet${a?'':' dtl-skel'}">
        ${a ? artSvg(a) : ''}
        <button class="dtl-open" data-id="${d.id}" aria-label="Open ${d.n}"></button>
        <button class="dtl-fav" data-fav="${d.id}" aria-pressed="${favs.has(d.id)}" aria-label="Save ${d.n}">
          <svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-9.3A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.7C19 15.6 12 20 12 20Z"/></svg>
        </button>
        <span class="dtl-cta-slip">Size &amp; print</span>
      </div>
      <div class="dtl-meta"><div class="dtl-nm">${d.n}</div>
        <div class="dtl-sub"><span class="dtl-badge dtl-${d.lv}">${dots(d.lv)}${LVLABEL[d.lv]||cap1(d.lv)}</span>
          <span class="dtl-coll">${COLNAME[d.c]}</span></div></div>
    </article>`;
}
/* Clic en una tarjeta: el corazón guarda, el resto abre el diseño. */
function onCardClick(e, from){
  const f = e.target.closest('[data-fav]');
  if(f){ e.stopPropagation(); const id=f.dataset.fav;
    favs.has(id)?favs.delete(id):favs.add(id);
    document.querySelectorAll(`[data-fav="${id}"]`).forEach(x=>x.setAttribute('aria-pressed', favs.has(id)));
    saveFavs();
    track('favourite_toggled', {design:id, on:favs.has(id)}); if(fFav) render(); return; }
  const c = e.target.closest('.dtl-card'); if(!c) return;
  if(from) track('related_opened', {from, to:c.dataset.id});
  open(c.dataset.id);
}
function render(){
  const items = list();
  BY('grid').innerHTML = items.map((d,i)=>card(d,i)).join('');
  const scope = (fQ||fFav) ? `${INDEX.length} designs`
              : curCol==='all' ? 'all collections' : COLNAME[curCol];
  BY('hits').innerHTML = `<b>${items.length}</b> in ${scope}`;
  BY('empty').hidden = items.length > 0;
}

BY('cols').addEventListener('click', e=>{
  const b = e.target.closest('[data-c]'); if(!b) return;
  curCol = b.dataset.c;
  track('collection_selected', {collection:curCol});
  document.querySelectorAll('#dtl-cols .dtl-tab').forEach(t=>t.setAttribute('aria-pressed', t===b));
  fQ=''; fFav=false; BY('q').value='';
  document.querySelector('#dtl-ex .dtl-pill').setAttribute('aria-pressed','false');
  render();
  if (curCol==='all') loadAllSeq(); else loadCols(curCol).then(render);
  centerTab(b, false);
});
BY('grid').addEventListener('click', e=>onCardClick(e));
BY('lv').addEventListener('click', e=>{
  const b=e.target.closest('[data-lv]'); if(!b) return; fLv=b.dataset.lv; track('detail_filtered', {level:fLv});
  e.currentTarget.querySelectorAll('.dtl-pill').forEach(p=>p.setAttribute('aria-pressed', p===b)); render();
});
BY('ex').addEventListener('click', e=>{
  const b=e.target.closest('[data-ex]'); if(!b) return;
  fFav=!fFav; track('saved_filter_toggled', {on:fFav}); b.setAttribute('aria-pressed',fFav); render(); if(fFav) loadAllSeq();
});
BY('q').addEventListener('input', e=>{
  fQ = e.target.value.trim().toLowerCase();
  if(fQ.length>=2) track('search_performed', {query:fQ});
  render(); if(fQ) loadAllSeq();
});
BY('reset').onclick = ()=>{
  fLv='all'; fFav=false; fQ=''; BY('q').value='';
  document.querySelectorAll('#dtl-lv .dtl-pill').forEach(p=>p.setAttribute('aria-pressed', p.dataset.lv==='all'));
  document.querySelector('#dtl-ex .dtl-pill').setAttribute('aria-pressed','false'); render();
};


/* ────── sizer.js ────── */
/* =============================================================
   sizer.js — la herramienta de tamaño.
   Una sola función de geometría alimenta el preview en pantalla y el
   PDF, así lo que se ve es exactamente lo que se imprime.
   Coordenadas en puntos PDF, origen abajo-izquierda.
   ============================================================= */

let cur=null, sizeCm=PRESETS[1].inch*CM_IN, unit='in', sheet='letter', orient='portrait';

const fmtN = cm => {
  const v = unit==='in' ? cm/CM_IN : cm;
  return (Math.round(v*100)/100).toFixed(v<10?2:1).replace(/\.?0+$/,'');
};
const fmt = cm => fmtN(cm) + (unit==='in' ? ' in' : ' cm');

function dims(){
  const ar = cur.w/cur.h;
  return ar >= 1 ? {w:sizeCm, h:sizeCm/ar} : {w:sizeCm*ar, h:sizeCm};
}
function layout(){
  const A = ART[cur.id]; if(!A) return null;
  const P = PAPERS[sheet];
  const pg = orient==='portrait' ? {w:P.w, h:P.h} : {w:P.h, h:P.w};
  const c = dims();
  const wPt = c.w*PT_CM, hPt = c.h*PT_CM;
  const availW = pg.w - 2*MARGIN;
  const availH = pg.h - 2*MARGIN - HEAD - FOOT;
  const x = (pg.w - wPt)/2;
  const yBot = MARGIN + FOOT + (availH - hPt)/2;
  const kw = c.w/sizeCm, kh = c.h/sizeCm;          // proporción respecto del lado mayor
  return { A, pg, cm:c, wPt, hPt, x, yBot, availW, availH,
           fits: wPt <= availW+0.01 && hPt <= availH+0.01,
           maxCm: Math.min(availW/PT_CM/kw, availH/PT_CM/kh) };
}

/* primitivas de la hoja: el preview y el PDF dibujan esta misma lista */
function primitives(L){
  const {pg, A, wPt, hPt, x, yBot} = L;
  const P = [], RULE='#C8D1D9', DIM='#7C8894', INK='#111111';

  P.push({t:'art', d:A.d, vbX:A.x, vbY:A.y, vbW:A.w, vbH:A.h, x, y:yBot, w:wPt, h:hPt});

  P.push({t:'text', x:MARGIN, y:pg.h-MARGIN-9, s:9, f:'sans', txt:cur.n, col:INK});
  P.push({t:'text', x:pg.w-MARGIN, y:pg.h-MARGIN-9, s:9, f:'sans', a:'end',
          txt:`${fmtN(L.cm.w)} x ${fmtN(L.cm.h)} ${unit}`, col:DIM});
  P.push({t:'line', x1:MARGIN, y1:pg.h-MARGIN-17, x2:pg.w-MARGIN, y2:pg.h-MARGIN-17, w:.4, col:RULE});

  if (L.fits){
    const yd = yBot - 15;
    P.push({t:'line', x1:x, y1:yd, x2:x+wPt, y2:yd, w:.5, col:DIM});
    P.push({t:'line', x1:x, y1:yd-3, x2:x, y2:yd+3, w:.5, col:DIM});
    P.push({t:'line', x1:x+wPt, y1:yd-3, x2:x+wPt, y2:yd+3, w:.5, col:DIM});
    P.push({t:'text', x:x+wPt/2, y:yd-11, s:8, a:'mid', txt:fmt(L.cm.w), col:DIM});
    const xd = x - 15;
    P.push({t:'line', x1:xd, y1:yBot, x2:xd, y2:yBot+hPt, w:.5, col:DIM});
    P.push({t:'line', x1:xd-3, y1:yBot, x2:xd+3, y2:yBot, w:.5, col:DIM});
    P.push({t:'line', x1:xd-3, y1:yBot+hPt, x2:xd+3, y2:yBot+hPt, w:.5, col:DIM});
    P.push({t:'vtext', x:xd-4, y:yBot+hPt/2, s:8, a:'mid', txt:fmt(L.cm.h), col:DIM});
  }

  const isCm = unit==='cm', unitPt = isCm ? PT_CM : PT_IN, n = isCm ? 10 : 4;
  const rw = n*unitPt, rx = (pg.w-rw)/2, ry = MARGIN + 26;
  P.push({t:'line', x1:rx, y1:ry, x2:rx+rw, y2:ry, w:.7, col:INK});
  for (let i=0;i<=n;i++){
    const big = i%5===0;
    P.push({t:'line', x1:rx+i*unitPt, y1:ry, x2:rx+i*unitPt, y2:ry+(big?8:5), w:big?.7:.4, col:INK});
    if(big) P.push({t:'text', x:rx+i*unitPt, y:ry+11, s:7, a:'mid', txt:String(i), col:INK});
  }
  if (isCm) for (let i=0;i<n;i++)
    P.push({t:'line', x1:rx+(i+.5)*unitPt, y1:ry, x2:rx+(i+.5)*unitPt, y2:ry+3, w:.3, col:INK});

  P.push({t:'text', x:pg.w/2, y:ry-10, s:7.5, a:'mid', col:DIM,
          txt:`This ruler must measure exactly ${n} ${isCm?'cm':'inches'}`});
  P.push({t:'text', x:pg.w/2, y:MARGIN-2, s:7.5, a:'mid', col:DIM,
          txt:`Print at 100% / Actual size  -  no "Fit to page"  -  ${PAPERS[sheet].name}  -  resparked.com`});
  return P;
}

/* ---------- preview: la hoja en HTML, posicionada con esa misma geometría ---------- */
function paintArt(){
  if(!cur) return;
  const A = ART[cur.id], wrap = BY('artwrap');
  const old = wrap.querySelector('svg.dtl-art'); if(old) old.remove();
  if(A) wrap.insertAdjacentHTML('afterbegin', artSvg(A));
}
function paintSizes(){
  BY('sizes').innerHTML = PRESETS.map((s,i)=>`
    <button class="dtl-size" data-i="${i}" aria-pressed="${Math.abs(s.inch*CM_IN - sizeCm) < .01}">
      <span class="dtl-cm">${unit==='in' ? s.inch+' in' : (Math.round(s.inch*CM_IN*10)/10)+' cm'}</span>
      <span class="dtl-t2">${s.t}</span>
    </button>`).join('');
}
/* el campo es la fuente de verdad: siempre muestra la medida vigente */
function syncInput(){
  const v = unit==='in' ? sizeCm/CM_IN : sizeCm;
  BY('cust').value = Math.round(v*100)/100;
}
function update(){
  if(!cur) return;
  const L = layout();
  const P = PAPERS[sheet];
  const pg = orient==='portrait' ? {w:P.w,h:P.h} : {w:P.h,h:P.w};
  BY('page').style.aspectRatio = `${pg.w} / ${pg.h}`;

  const c = dims();
  const wrap = BY('artwrap');
  if (L){
    wrap.style.left   = (L.x/pg.w*100)+'%';
    wrap.style.bottom = (L.yBot/pg.h*100)+'%';
    wrap.style.width  = (L.wPt/pg.w*100)+'%';
    wrap.style.height = (L.hPt/pg.h*100)+'%';
  }
  BY('dw').textContent = fmt(c.w);
  BY('dh').textContent = fmt(c.h);

  const isCm = unit==='cm', unitPt = isCm?PT_CM:PT_IN, n = isCm?10:4;
  const rw = n*unitPt, ry = MARGIN + 26;
  const cal = BY('cal');
  cal.style.width  = (rw/pg.w*100)+'%';
  cal.style.left   = ((pg.w-rw)/2/pg.w*100)+'%';
  cal.style.bottom = (ry/pg.h*100)+'%';
  BY('calLbl').textContent = (isCm?'10 cm':'4 in') + ' · calibration';
  BY('band').style.bottom = ((MARGIN+FOOT)/pg.h*100)+'%';

  BY('r-w').textContent = fmt(c.w);
  BY('r-h').textContent = fmt(c.h);
  BY('r-p').textContent = PAPERS[sheet].name;
  BY('cap').textContent = `${PAPERS[sheet].name} ${orient} · shown to scale`;

  const min = MIN_CM[cur.lv];
  const el = BY('flag');
  const ico='<svg width="14" height="14" viewBox="0 0 24 24" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.4v.01"/></svg>';
  const ok ='<svg width="14" height="14" viewBox="0 0 24 24" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M8.2 12.4l2.6 2.6 5-5.4"/></svg>';
  if (sizeCm < min)
    el.innerHTML = `<div class="dtl-flag dtl-warn">${ico}<span><b>Needs a little more room.</b> Try ${fmt(min)} or bigger so every line stays crisp.</span></div>`;
  else if (L && !L.fits)
    el.innerHTML = `<div class="dtl-flag dtl-warn">${ico}<span><b>A bit big for one sheet.</b> Try ${fmt(L.maxCm)}, or turn the page sideways.</span></div>`;
  else
    el.innerHTML = `<div class="dtl-flag dtl-ok">${ok}<span>Fits your ${PAPERS[sheet].name} sheet with room to tape it down.</span></div>`;

  const g = BY('gen');
  if (g.classList.contains('dtl-done')){ g.classList.remove('dtl-done'); g.textContent='Get My Template'; }
  const m0=BY('msg'); m0.textContent=''; m0.className='dtl-msg';
}


/* ────── pdf.js ────── */
/* =============================================================
   pdf.js — generador de PDF escrito a mano, sin librerías.
   El diseño va como curvas vectoriales reales, no como imagen.
   Verificado: error máximo 0,0002 % sobre 7 combinaciones de
   diseño, medida, hoja y orientación. Ver docs/PDF-GENERATION.md.
   ============================================================= */
function pathToPdf(d, prec = 2){
  const N = d.length, ops = [];
  let i = 0, cx = 0, cy = 0, sx = 0, sy = 0;
  const r = v => (Math.round(v * 10 ** prec) / 10 ** prec).toString();
  const isNum = c => (c >= '0' && c <= '9') || c === '-' || c === '+' || c === '.';
  function num(){
    while (i < N && (d[i] === ' ' || d[i] === ',')) i++;
    const s = i;
    if (d[i] === '-' || d[i] === '+') i++;
    while (i < N && ((d[i] >= '0' && d[i] <= '9') || d[i] === '.')) i++;
    if (d[i] === 'e' || d[i] === 'E'){ i++; if (d[i] === '-' || d[i] === '+') i++;
      while (i < N && d[i] >= '0' && d[i] <= '9') i++; }
    return parseFloat(d.slice(s, i));
  }
  const more = () => { while (i < N && (d[i] === ' ' || d[i] === ',')) i++; return i < N && isNum(d[i]); };
  while (i < N){
    const c = d[i];
    if (c === ' ' || c === ','){ i++; continue; }
    if (!/[a-zA-Z]/.test(c)) break;
    i++;
    const rel = c === c.toLowerCase(), C = c.toUpperCase();
    if (C === 'Z'){ ops.push('h'); cx = sx; cy = sy; continue; }
    do {
      if (C === 'M' || C === 'L'){
        let X = num(), Y = num();
        if (rel){ X += cx; Y += cy; }
        ops.push(`${r(X)} ${r(Y)} ${C === 'M' ? 'm' : 'l'}`);
        cx = X; cy = Y;
        if (C === 'M'){ sx = X; sy = Y; }
      } else if (C === 'H' || C === 'V'){
        const v = num();
        if (C === 'H') cx = rel ? cx + v : v; else cy = rel ? cy + v : v;
        ops.push(`${r(cx)} ${r(cy)} l`);
      } else if (C === 'C'){
        const a = [num(),num(),num(),num(),num(),num()];
        const q = rel ? [a[0]+cx,a[1]+cy,a[2]+cx,a[3]+cy,a[4]+cx,a[5]+cy] : a;
        ops.push(`${r(q[0])} ${r(q[1])} ${r(q[2])} ${r(q[3])} ${r(q[4])} ${r(q[5])} c`);
        cx = q[4]; cy = q[5];
      } else return ops.join('\n');
    } while (more());
  }
  return ops.join('\n');
}
const pdfEsc = s => String(s).replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)');
const COURIER_W = 0.6, HELV_W = 0.52;

function buildPdf(){
  const L = layout(); if(!L) return null;
  const pg = L.pg, P = primitives(L);
  const n2 = v => (Math.round(v*100)/100).toString();
  /* La matriz necesita mucha más precisión que las coordenadas: la escala es un
     número chico (~0.2) que multiplica coordenadas de hasta ~2000, así que
     redondearla a 2 decimales correría la medida final hasta un 2 %. */
  const n6 = v => { let s = v.toFixed(6);
    if (s.indexOf('.') >= 0) s = s.replace(/0+$/,'').replace(/\.$/,'');
    return s === '-0' ? '0' : s; };
  const hex = c => [parseInt(c.slice(1,3),16)/255, parseInt(c.slice(3,5),16)/255,
                    parseInt(c.slice(5,7),16)/255].map(v=>v.toFixed(3)).join(' ');
  const S = [];
  for (const p of P){
    if (p.t === 'art'){
      const s = p.w / p.vbW;
      S.push('q','0 0 0 rg',
        `${n6(s)} 0 0 ${n6(-s)} ${n6(p.x - s*p.vbX)} ${n6(p.y + p.h + s*p.vbY)} cm`,
        pathToPdf(p.d), 'f*','Q');
    } else if (p.t === 'line'){
      S.push('q', `${hex(p.col)} RG`, `${n2(p.w)} w`,
        `${n2(p.x1)} ${n2(p.y1)} m ${n2(p.x2)} ${n2(p.y2)} l S`, 'Q');
    } else {
      const sans = p.f === 'sans';
      const font = sans ? '/F1' : '/F2';
      const w = p.txt.length * (sans ? HELV_W : COURIER_W) * p.s;
      let dx = 0;
      if (p.a === 'mid') dx = -w/2; else if (p.a === 'end') dx = -w;
      S.push('q', `${hex(p.col)} rg`, 'BT', `${font} ${n2(p.s)} Tf`);
      if (p.t === 'vtext') S.push(`0 1 -1 0 ${n2(p.x)} ${n2(p.y + dx)} Tm`);
      else                 S.push(`1 0 0 1 ${n2(p.x + dx)} ${n2(p.y)} Tm`);
      S.push(`(${pdfEsc(p.txt)}) Tj`, 'ET', 'Q');
    }
  }
  const content = S.join('\n');
  const objs = [
    '<</Type/Catalog/Pages 2 0 R>>',
    '<</Type/Pages/Kids[3 0 R]/Count 1>>',
    `<</Type/Page/Parent 2 0 R/MediaBox[0 0 ${n2(pg.w)} ${n2(pg.h)}]` +
      '/Resources<</Font<</F1 5 0 R/F2 6 0 R>>>>/Contents 4 0 R>>',
    `<</Length ${content.length}>>\nstream\n${content}\nendstream`,
    '<</Type/Font/Subtype/Type1/BaseFont/Helvetica/Encoding/WinAnsiEncoding>>',
    '<</Type/Font/Subtype/Type1/BaseFont/Courier/Encoding/WinAnsiEncoding>>'
  ];
  let out = '%PDF-1.4\n%\xE2\xE3\xCF\xD3\n';
  const off = [];
  objs.forEach((o,k)=>{ off.push(out.length); out += `${k+1} 0 obj\n${o}\nendobj\n`; });
  const xref = out.length;
  out += `xref\n0 ${objs.length+1}\n0000000000 65535 f \n`;
  off.forEach(o => { out += String(o).padStart(10,'0') + ' 00000 n \n'; });
  out += `trailer\n<</Size ${objs.length+1}/Root 1 0 R>>\nstartxref\n${xref}\n%%EOF\n`;
  const bytes = new Uint8Array(out.length);
  for (let k=0;k<out.length;k++) bytes[k] = out.charCodeAt(k) & 0xff;
  return bytes;
}

let dlCap;
async function getDownloads(){
  if (dlCap !== undefined) return dlCap;
  try { dlCap = (window.claude && window.claude.use) ? await window.claude.use('downloads') : null; }
  catch(e){ dlCap = null; }
  return dlCap;
}


/* ────── app.js ────── */
/* =============================================================
   app.js — apertura del detalle, cableado de eventos y arranque.
   ============================================================= */
/* ---------- more like this ----------
   Relacionados = los siguientes diseños de la MISMA colección, en el orden
   del catálogo, dando la vuelta al final. Así cambian con cada diseño y
   nunca incluyen el que se está viendo. Decisión de producto: por ahora
   sólo por colección, sin tags (ver docs/PENDING-DECISIONS.md). */
function related(d){
  const pool = INDEX.filter(x => x.c === d.c);
  const i = pool.indexOf(d);
  const out = [];
  for (let k = 1; k < pool.length && out.length < RELATED_COUNT; k++)
    out.push(pool[(i + k) % pool.length]);
  return out;
}
function paintRelated(){
  const sec = BY('more');
  if(!cur){ sec.hidden = true; return; }
  const items = related(cur);
  sec.hidden = items.length === 0;
  BY('moreGrid').innerHTML = items.map(x => card(x)).join('');
  BY('moreAll').textContent = `See all ${COLNAME[cur.c]} →`;
}
BY('moreGrid').addEventListener('click', e => onCardClick(e, cur && cur.id));
BY('moreAll').addEventListener('click', () => {
  if(!cur) return;
  track('related_see_all', {from:cur.id, collection:cur.c});
  ROOT.classList.remove('dtl-on-detail');
  fLv='all'; document.querySelectorAll('#dtl-lv .dtl-pill').forEach(p=>p.setAttribute('aria-pressed', p.dataset.lv==='all'));
  document.querySelector(`#dtl-cols .dtl-tab[data-c="${cur.c}"]`)?.click();
  document.querySelector('.dtl-tools').scrollIntoView({block:'start', behavior:'instant'});
});

/* ---------- nombre del PDF ----------
   Nombre visible del diseño + tamaño de impresión, p.ej.
   "Hanging Ornaments - 3.5 in.pdf" o "Seahorse - 12 cm.pdf".
   Se quitan los caracteres que Windows/macOS no aceptan en un nombre. */
function pdfName(d, cm, u){
  const safe = d.n
    .replace(/[^A-Za-z0-9 &-]+/g, '')   // fuera acentos, comillas y signos raros
    .replace(/[\s&]+/g, '-')            // espacios -> guiones
    .replace(/-+/g, '-').replace(/^-|-$/g, '')
    .slice(0, 40) || d.id;
  return `Resparked_${safe}_${fmtN(cm)}${u}.pdf`;
}

/* ---------- apertura y eventos ---------- */
function open(id){
  const d = INDEX.find(x=>x.id===id); if(!d) return;
  cur = d;
  track('design_opened', {id:d.id, collection:d.c, level:d.lv});
  sizeCm = PRESETS[1].inch*CM_IN;
  orient = d.w > d.h*1.05 ? 'landscape' : 'portrait';
  BY('d-name').textContent = d.n;
  const tag = BY('d-lv');
  tag.textContent = LVLABEL[d.lv] || cap1(d.lv); tag.className = 'dtl-tag dtl-badge' + d.lv;
  BY('d-where').textContent = COLNAME[d.c];
  BY('f3').classList.remove('dtl-on');
  const g = BY('gen');
  g.textContent = 'Get My Template'; g.classList.remove('dtl-done'); g.disabled = false;
  const m0=BY('msg'); m0.textContent=''; m0.className='dtl-msg';
  document.querySelectorAll('#dtl-orient button').forEach(b=>b.setAttribute('aria-pressed', b.dataset.o===orient));
  loadCol(d.c).then(()=>{ if(cur!==d) return; paintArt(); update(); paintRelated(); });
  paintArt(); syncInput(); paintSizes(); update(); paintRelated();
  ROOT.classList.add('dtl-on-detail');
  scrollTo({top:0, behavior:'instant'});
}
BY('sizes').addEventListener('click', e=>{
  const b=e.target.closest('[data-i]'); if(!b) return;
  sizeCm = PRESETS[+b.dataset.i].inch*CM_IN;
  track('size_preset_selected', {design:cur&&cur.id, inch:PRESETS[+b.dataset.i].inch});
  syncInput(); paintSizes(); update();
});
BY('cust').addEventListener('input', e=>{
  const v=parseFloat(e.target.value); if(!(v>0)) return;
  sizeCm = unit==='in' ? v*CM_IN : v;
  track('size_custom_entered', {design:cur&&cur.id, value:v, unit});
  paintSizes(); update();
});
BY('unit').addEventListener('click', e=>{
  const b=e.target.closest('[data-u]'); if(!b||b.dataset.u===unit) return;
  unit=b.dataset.u;
  track('unit_changed', {unit});
  e.currentTarget.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', x===b));
  syncInput(); paintSizes(); update();
});
BY('paper').addEventListener('click', e=>{
  const b=e.target.closest('[data-p]'); if(!b) return; sheet=b.dataset.p; track('sheet_changed', {sheet});
  e.currentTarget.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', x===b)); update();
});
BY('orient').addEventListener('click', e=>{
  const b=e.target.closest('[data-o]'); if(!b) return; orient=b.dataset.o; track('orientation_changed', {orient});
  e.currentTarget.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', x===b)); update();
});
BY('gen').addEventListener('click', async function(){
  if(!cur || !ART[cur.id]) return;
  const msg = BY('msg');
  msg.className='dtl-msg'; msg.textContent='Getting your template ready…';
  this.disabled = true;
  await new Promise(r=>setTimeout(r,16));
  track('pdf_generate_clicked', {design:cur.id, sizeCm:Math.round(sizeCm*100)/100, unit, sheet, orient});
  let bytes;
  try { bytes = buildPdf(); } catch(err){ bytes = null; }
  if(!bytes){ msg.className='dtl-msg dtl-err'; msg.textContent='Something went wrong. Give it another go.'; this.disabled=false; return; }
  const name = pdfName(cur, sizeCm, unit);
  const done = () => {
    msg.className='dtl-msg';
    msg.innerHTML = SPARK_SM + `<span>Saved as <b>${name}</b>. Now go make it yours.</span>`;
    msg.classList.add('dtl-win');
    this.textContent = '✓ Template Ready'; this.classList.add('dtl-done');
    track('pdf_downloaded', {design:cur.id, filename:name, sheet, orient});
    BY('f3').classList.add('dtl-on');
  };
  const cap = await getDownloads();
  if (cap){
    try { await cap.save({filename:name, data:bytes.buffer.slice(0)}); done(); }
    catch(err){
      msg.className='dtl-msg dtl-err';
      msg.textContent = err && err.code==='declined'
        ? 'No worries — nothing was saved.' : "Couldn't save that one. Try again?";
    }
  } else {
    const blob = new Blob([bytes], {type:'application/pdf'});
    let shared = false;
    try {
      const file = new File([blob], name, {type:'application/pdf'});
      const tactil = matchMedia('(hover:none) and (pointer:coarse)').matches;
      if (tactil && navigator.canShare && navigator.canShare({files:[file]})) {
        await navigator.share({files:[file], title:name});
        shared = true; done();
      }
    } catch (err) {
      if (err && err.name === 'AbortError') {        /* el usuario cancelo */
        shared = true;
        msg.className = 'msg'; msg.textContent = '';
        this.textContent = 'Get My Template';
      }
      /* cualquier otro error: cae al camino de descarga de abajo */
    }
    if (!shared) { saveBlob(blob, name); done(); }
  }
  this.disabled = false;
});
BY('back').onclick = ()=>{
  ROOT.classList.remove('dtl-on-detail'); scrollTo({top:0, behavior:'instant'});
};
addEventListener('keydown', e=>{
  if(e.key==='Escape' && ROOT.classList.contains('dtl-on-detail')) BY('back').click();
});

/* ---------- arranque ---------- */
function paintNav(){
  const _nav = document.querySelector('.bar nav');
  if (!_nav) return;   /* el header lo pone el theme */
  _nav.innerHTML = NAV.map(n =>
    `<a href="${n.href}"${n.current ? ' aria-current="page"' : ''}>${n.label}</a>`).join('');
}
function paintFilters(){
  BY('lv').innerHTML =
    `<span>${LEVEL_FILTER_LABEL}</span>` + '<button class="dtl-pill" data-lv="all" aria-pressed="true">All</button>' +
    LEVELS.map(l => `<button class="dtl-pill" data-lv="${l.slug}" aria-pressed="false">${l.label}</button>`).join('');
}
async function boot(){
  paintNav(); paintFilters();
  try { await loadIndex(); }
  catch (err) {
    BY('grid').innerHTML =
      '<p style="grid-column:1/-1;color:var(--muted)">Could not load the design library.</p>';
    return;
  }
  ROOT.querySelectorAll('[data-count="designs"]').forEach(el => el.textContent = INDEX.length);
  ROOT.querySelectorAll('[data-count="collections"]').forEach(el => el.textContent = COLS.length);
  ROOT.querySelectorAll('[data-count="levels"]').forEach(el => el.textContent = LEVELS.length);
  tabs(); render(); loadAllSeqGated();
  centerTab(BY('cols').querySelector('.dtl-tab[aria-pressed="true"]'), true);
}
if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', boot);
else boot();

})();
